export default {
    LOAD_LOCAL: false, // true - local/ false - from server(stage or prod)

    CONTEXT: 'edit', // edit, player, print, printEditor, download, audioTool, audioToolPlayer, exportPlayer, exportAudioPlayer
    LOAD_BLANK_PRODUCTION: true,
    AUTOSAVE_AVAILABLE: true,
    AUTOSAVE_TIME: 15, // defined in seconds
    MEDIA_FILES_PAGE_LIMIT: 1500,
    CANVAS_WIDTH: 800,
    CANVAS_HEIGHT: 450,
    SLIDE_DURATION: 4, // defined in seconds
    SCREENSHOT_WIDTH: 400,
    USE_WAVEFORM: true,
    FIRST_PRELOADED_SLIDES: 2, // the rest of slide are preloaded in background

    AUDIO_TOOL_CLIRPART_ID_STAGE: 75314197,
    AUDIO_TOOL_CLIRPART_ID_PROD: 78231078,
    MASTER_CLIPART_ID: 62348494,
    MASTER_CLIPART_ID_PROD: 62348494,
    DEFAULT_CLIPART_ID: 102264236, // Animals
    DEFAULT_CLIPART_ID_PROD: 102264236, // Animals

    IS_PROD() {
        if (window.location.href.indexOf('stage') != -1)
            return false;
        else
            return true;
    }
};



/** WEBPACK FOOTER **
 ** ./src/constants/Configuration.js
 **/